const INTRO_HOLD_MS = 1800;
const INTRO_SCROLL_MS = 2800;

export const chainUnlockAnimation = {
  data() {
    return {
      unlockingIndex: -1,
    };
  },
  methods: {
    // Quick jiggle on the lock icon (not the whole tile) to signal it can't be
    // bought yet.
    jiggleTile(index) {
      const el = document.getElementById("chain-lock-" + index);
      if (!el) return;
      this.gsap.killTweensOf(el);
      this.gsap.to(el, {
        keyframes: {
          rotation: [0, -12, 10, -8, 6, -4, 2, 0],
        },
        duration: 0.7,
        ease: "power1.inOut",
        onComplete: () => this.gsap.set(el, { clearProps: "transform" }),
      });
    },
    runScrollAndMaybeUnlock() {
      const idx = this.currentIndex;

      if (this.$store.state.shop.offerChainUnlockAnim) {
        this.unlockingIndex = idx;
        this.scheduleScrollToCurrent(
          0,
          () => {
            this.$store.commit("shop/setOfferChainUnlockAnim", false);
            this.playUnlock();
          },
          Math.max(0, idx - 1)
        );
        return;
      }

      // Play the intro every open until the user buys their first offer in this
      // chain (backend-driven: no package collected yet).
      const noneCollected = !this.sortedPackages.some(
        (p) => this.packageState(p) === "collected"
      );
      const playIntro = this.sortedPackages.length > 1 && noneCollected;
      if (playIntro) {
        const lastIndex = this.sortedPackages.length - 1;
        this.scheduleScrollToCurrent(
          0,
          null,
          lastIndex,
          INTRO_HOLD_MS,
          true,
          () => this.introEnter(lastIndex),
          INTRO_SCROLL_MS,
          () => this.introRevealRest(lastIndex)
        );
        return;
      }

      this.scheduleScrollToCurrent(0, null, 0);
    },
    introEnter(lastIndex) {
      const container = this.$refs.container;
      if (!container) return;
      const els = container.querySelectorAll(".chain-package, .chain-arrow");
      this.gsap.killTweensOf(els);
      this.gsap.set(els, { opacity: 0 });

      const last = document.getElementById("chain-tile-" + lastIndex);
      if (!last) return;
      this.gsap.set(last, {
        scale: 0,
        opacity: 0,
        transformOrigin: "center center",
      });
      this.gsap.to(last, {
        scale: 1,
        opacity: 1,
        duration: 0.7,
        delay: 0.4,
        ease: "back.out(1.7)",
        onComplete: () => this.gsap.set(last, { clearProps: "transform" }),
      });
    },
    introRevealRest(lastIndex) {
      const container = this.$refs.container;
      if (!container) return;
      const els = container.querySelectorAll(".chain-package, .chain-arrow");
      const others = Array.from(els).filter(
        (el) => el.id !== "chain-tile-" + lastIndex
      );
      this.gsap.to(others, {
        opacity: 1,
        duration: 0.3,
        ease: "power1.out",
        onComplete: () => this.gsap.set(els, { clearProps: "opacity" }),
      });
    },
    // Lock flies out to the right, revealing the (already-visible) buy button
    // underneath. The button does not move or fade — only the lock animates.
    playUnlock() {
      this.$nextTick(() => {
        const lock = document.getElementById("chain-unlock-lock");
        if (!lock) {
          this.unlockingIndex = -1;
          return;
        }
        this.gsap.set(lock, { x: 0, opacity: 1 });
        this.gsap.to(lock, {
          x: 260,
          opacity: 0,
          duration: 0.45,
          ease: "power2.in",
          onComplete: () => {
            this.unlockingIndex = -1;
            this.pulseButton();
          },
        });
      });
    },
    pulseButton() {
      const btn = document.getElementById("chain-price-" + this.currentIndex);
      if (btn) {
        this.gsap.killTweensOf(btn);
        // xPercent:-50 preserves the CSS translateX(-50%) centering while scaling.
        this.gsap.fromTo(
          btn,
          { xPercent: -50, scale: 1 },
          {
            keyframes: [
              { scale: 1.18, duration: 0.13 },
              { scale: 0.97, duration: 0.1 },
              { scale: 1.09, duration: 0.1 },
              { scale: 1, duration: 0.12 },
            ],
            ease: "power1.inOut",
            onComplete: () => this.gsap.set(btn, { clearProps: "transform" }),
          }
        );
      }
      if (typeof this.playSoundNotification === "function") {
        this.playSoundNotification();
      }
    },
  },
};
